var useThemeWithoutDefault = {};

export { useThemeWithoutDefault as __exports };
